export class Groups {
  id: number;
  description: string;
  autoEntrant: boolean;
  autoSortant: boolean;
  autoServiceId: number;
  autoNatureId: number;
  groupeADLie: string;

  constructor(data: Partial<Groups>) {
    Object.assign(this, data);
  }
}
